<template>
  <div class="dialog_container" v-if="visible">
    <div class="dialog_mask" @click="hideDialog"></div>
    <div class="dialog_wrap">
      <div class="dialog_head">
        <div class="dialog_head_title" @click="hideDialog">
          <span>Login</span>
          <img class="dialog_head_tit_close" src="@/assets/img/public/icon_close.png"/>
        </div>
        <div class="dialog_head_line"><img src="@/assets/img/public/line_fennge.png"/></div>
      </div>
      <div class="dialog_body">
        <div class="login_list">
          <div class="login_item" @click="getMetaMaskTrade"><img src="@/assets/img/public/METAMASK_logo.png"/></div>
          <!-- <div class="login_item"><img src="@/assets/img/public/Walletconnect_logo.png"/></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dialog-login',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideDialog() {
      this.$emit('hideDialog');
    },
    // call MetaMsk
    getMetaMaskTrade() {
        this.$emit('getMetaMaskTrade');
    }
  }
}
</script>

<style scoped>

</style>
